<template>
  <div class="page" data-page="form">
    <Header @toggleDrawer="toggleDrawer" />
    <div class="container pt-4">
      <div class="page-form-row row" :style="{ display: this.$store.getters.getLoading ? 'none' : 'block' }">
        <template v-if="appData">
          <div class="col-3 card nav-card">
            <FormNavigation :sections="appData.Sections" :isRoot="true" />
          </div>
          <div class="col-6 card main-card" ref="mainCard">
            <Carousel :isFormData="true" ref="carousel">
              <template v-for="(page, page_index) in appData.Fields">
                <Slide :index="page_index" :sectionid="page.SectionID" :pageid="page.Id" :key="'page_' + page_index">
                  <Field :data="page" :sectionid="page.SectionID" :pageid="page.Id" />
                </Slide>
              </template>
            </Carousel>
          </div>
          <div class="col-3 card officer-card">
            <div class="officer-photo" :style="{ 'background-image': 'url(' + this.$store.getters.getAvatar + ')' }" v-if="this.$store.getters.getAvatar"></div>
            <div v-else></div>
            <h2 class="bold">{{ this.$store.getters.getFullName }}</h2>
            <div class="sub text-gray" v-if="this.$store.getters.getTitle">
              {{ this.$store.getters.getTitle }}
            </div>
            <div class="sub text-gray" v-if="this.$store.getters.getNMLS">
              <a href="https://nmlsconsumeraccess.org/" target="_blank">NMLS#: {{ this.$store.getters.getNMLS }}</a>
            </div>
            <hr />
            <div class="officer-contact">
              <div class="contact-phone" v-if="this.$store.getters.getPhone">
                <a :href="'tel:' + this.$store.getters.getPhone"><icon icon="phone" />
                  {{ this.$store.getters.getPhone }}
                </a>
              </div>
              <div class="contact-email" v-if="this.$store.getters.getEmail">
                <a :href="'mailto:' + this.$store.getters.getEmail"><icon icon="envelope" />
                  {{ this.$store.getters.getEmail }}
                </a>
              </div>
              <div class="contact-website" v-if="this.$store.getters.getWebsite">
                <a :href="this.$store.getters.getWebsite" target="_blank"><icon icon="globe" /> 
                  {{ this.$store.getters.getWebsite }}
                </a>
              </div>
            </div>
          </div>
          <div class="nav-card-mobile">
            <FormNavigation :sections="appData.Sections" :isRoot="true" :isMobile="true" />
          </div>
        </template>
      </div>
    </div>
    <DisclaimerFooter />

    <template v-for="(toast, index) in $store.getters.getToasts">
      <Toast :data="toast" :index="index" :key="'toast_' + index" />
    </template>

    <Drawer :position="'right'" :size="260" :open="drawerOpen" @toggleDrawer="toggleDrawer">
      <div class="card officer-card drawer-card">
        <div class="officer-photo" :style="{ 'background-image': 'url(' + this.$store.getters.getAvatar + ')' }" v-if="this.$store.getters.getAvatar"></div>
        <div v-else></div>
        <h2 class="bold">{{ this.$store.getters.getFullName }}</h2>
        <div class="sub text-gray" v-if="this.$store.getters.getTitle">
          {{ this.$store.getters.getTitle }}
        </div>
        <div class="sub text-gray" v-if="this.$store.getters.getNMLS">
          <a href="https://nmlsconsumeraccess.org/" target="_blank">NMLS#: {{ this.$store.getters.getNMLS }}</a>
        </div>
        <hr />
        <div class="officer-contact">
          <div class="contact-phone" v-if="this.$store.getters.getPhone">
            <a :href="'tel:' + this.$store.getters.getPhone"><icon icon="phone" />
              {{ this.$store.getters.getPhone }}
            </a>
          </div>
          <div class="contact-email" v-if="this.$store.getters.getEmail">
            <a :href="'mailto:' + this.$store.getters.getEmail"><icon icon="envelope" />
              {{ this.$store.getters.getEmail }}
            </a>
          </div>
          <div class="contact-website" v-if="this.$store.getters.getWebsite">
            <a :href="this.$store.getters.getWebsite" target="_blank"><icon icon="globe" /> 
              {{ this.$store.getters.getWebsite }}
            </a>
          </div>
        </div>
      </div>
    </Drawer>

    <Modal :open="creditAuthOpen" @toggleModal="toggleCreditAuth">
      <template v-slot:body>
        <Localize :text="activeConfig.Disclaimers.CreditAuthorization" />
      </template>
    </Modal>

    <Modal :open="privacyPolicyOpen" @toggleModal="togglePrivacyPolicy">
      <template v-slot:body>
        <Localize :text="activeConfig.Disclaimers.PrivacyPolicy" />
      </template>
    </Modal>

    <Modal :open="eConsentOpen" @toggleModal="toggleEConsent">
      <template v-slot:body>
        <Localize :text="activeConfig.Disclaimers.EConsent" />
      </template>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import PreApproveMe from '@/services/PreApproveMe.js'
import Header from '@/components/Header.vue'
import Modal from '@/components/Modal.vue'
import Toast from '@/components/Toast.vue'
import Carousel from '@/components/Carousel.vue'
import Slide from '@/components/Slide.vue'
import FormNavigation from '@/components/FormNavigation.vue'
import Drawer from '@/components/Drawer.vue'
import Localize from '@/components/Localize.vue'
import DisclaimerFooter from '@/components/DisclaimerFooter.vue'

export default {
  name: 'PageForm',
  components: {
    Header,
    Modal,
    Toast,
    Carousel,
    Slide,
    FormNavigation,
    Drawer,
    Localize,
    DisclaimerFooter
  },
  data: () => {
    return {
      //appData: false
      drawerOpen: false,
      creditAuthOpen: false,
      privacyPolicyOpen: false,
      eConsentOpen: false
    }
  },
  computed: {
    appData: function () {
      return this.$store.getters.getFormStructure
    },
    activeConfig: function () {
      return this.$store.getters.getOfficerConfig || this.$store.getters.getCompanyConfig
    },
    reviewActive: function () {
      return this.$store.getters.isNavActive('smart1003_screen_review')
    },
    loanDetailsActive: function () {
      return this.$store.getters.isNavActive('smart1003_section_loan_data')
    }
  },
  watch: {
    reviewActive: function (val) {
      if (val) {
        const prevBorrowerID = this.$store.state.borrowerid
        this.$store.commit('becomeBorrower', 0)
        const newBorrowerID = this.$store.state.borrowerid
        if (prevBorrowerID !== newBorrowerID) this.$root.$emit('borrower:change')
      }
    },
    loanDetailsActive: function (val) {
      if (val) {
        const prevBorrowerID = this.$store.state.borrowerid
        this.$store.commit('becomeBorrower', 0)
        const newBorrowerID = this.$store.state.borrowerid
        if (prevBorrowerID !== newBorrowerID) this.$root.$emit('borrower:change')
      }
    }
  },
  methods: {
    toggleDrawer: function () {
      this.drawerOpen = !this.drawerOpen
    },
    toggleCreditAuth: function () {
      this.creditAuthOpen = !this.creditAuthOpen
    },
    togglePrivacyPolicy: function () {
      this.privacyPolicyOpen = !this.privacyPolicyOpen
    },
    toggleEConsent: function () {
      this.eConsentOpen = !this.eConsentOpen
    }
  },
  created: function() {
    // this.$root.$on('borrower:change', loadData)
  },
  updated: function() {
    // this.updateActiveNavHeight()
  },
  mounted: function() {
    const $this = this

    if (this.$store.state.companyid === false || this.$store.state.userid === false || this.$store.state.borrowers.length == 0) {
      this.$store.dispatch('go', 'start')
      return
    }

    // Get Company ID
    const companyid = this.$store.getters.getCompany.CompanyID

    // Get Officer ID
    const officerid = (this.$store.getters.getOfficer || {}).UserID || null

    const realtorid = this.$store.getters.getRealtor

    $this.$store.commit('setLoading', true)
    PreApproveMe.loadForm(companyid, officerid, realtorid)
      .then(response => {
        if (typeof response == 'object' && response.data && response.data.Success) {
          // Initialize app data
          $this.$store.commit('initForm', response.data)
          $this.$store.dispatch('navInit', response.data)

/*
          // Load save data
          PreApproveMe.loadSave(companyid, officerid, 'BORROWERIDGOESHERE').then(resp => {
            console.log('LoadSave Response', resp)
            if (resp.data.Success) {
              if (resp.data.SaveData) {
                for (let i = 0; i < resp.data.SaveData.length; i++) {
                  const currData = resp.data.SaveData[i]
                  if (currData.BorrowerID && currData.FormData) {
                    $this.$store.state.saveData[currData.BorrowerID] =
                      currData.FormData
                    console.log(
                      'Loaded data for BorrowerID ' + currData.BorrowerID
                    )
                  }
                }
              } else {
                console.log('No saves to load.')
              }
            } else {
              console.log('Error loading saved data. Invalid response.')
            }
          })
*/

          // Set appData
          //$this.appData = response.data.FormStructure
        } else {
          console.log('Error: Invalid API response.')
        }

        $this.$store.commit('setLoading', false)
      })
      .catch(error => {
        console.log('Error: Invalid API response.', error)
        $this.$store.commit('setLoading', false)
      })

    this.$root.$on('modal:creditauth', this.toggleCreditAuth)
    this.$root.$on('modal:privacypolicy', this.togglePrivacyPolicy)
    this.$root.$on('modal:econsent', this.toggleEConsent)
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.page[data-page='form'] {

  .page-form-row {
    padding-bottom: 100px;

    .officer-card {
      @media (max-width: 992px) {
        display: none;
      }
    }
  }

  .drawer-card {
     box-shadow: none;
   }

  .nav-card {
    @media (max-width: 992px) {
      display: none;
    }
  }

  .nav-card-mobile {
    display: none;
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: white;
    //height: 65px;
    box-shadow: 6px 6px 6px 6px #d8dada;

    @media (max-width: 992px) {
      display: block;
    }
  }

  .card.officer-card {
    position: relative;
    padding: 2rem 0;
    text-align: center;

    h2 {
      margin: 18px 0 4px;
    }

    div.sub {
      font-size: 0.9rem;
      margin-bottom: 4px;
    }

    hr {
      margin-top: 2.5em;
    }

    .officer-photo {
      display: inline-block;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background-color: $medium-gray;
      background-image: url('../assets/default-avatar.png');
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .officer-contact {
      width: 85%;
      display: inline-block;
      text-align: left;
      .contact-phone,
      .contact-email,
      .contact-website {
        width: 100%;
        padding-top: 4px;
        padding-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: $primary;
        &:last-child {
          padding-bottom: 0;
        }
        .svg-inline--fa {
          float: left;
          color: $primary;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
